import React from 'react'
import { Star } from '@phosphor-icons/react';

export default function RatingChip({ rate }) {

    return (
        <div className='px-1.5 py-1 rounded-md bg-yellow text-white font-semibold text-sm leading-none inline-flex items-center'>
            <Star className='w-3 h-3 mr-1 fill-white' weight="fill"/>
            {rate}
        </div>
    )
}